export interface CardSwitchOption {
  value: string;
  label: string;
  sub?: string;
  /** A prominent count pill (e.g. pending work for a language). */
  badge?: number;
  /** Dim the card — used to de-emphasise options with nothing pending. */
  muted?: boolean;
}

/**
 * A row of selectable cards for switching a single value (e.g. the language a
 * page is scoped to). App-agnostic: the caller maps domain values to
 * {value,label,sub,badge,muted}. Render it only when there's more than one
 * option. `badge` surfaces a per-option count so the busiest option is obvious
 * without opening each one; `muted` greys out options with none.
 */
export function CardSwitch({
  label,
  options,
  value,
  onChange,
}: {
  label?: string;
  options: CardSwitchOption[];
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <div style={{ marginBottom: 20 }}>
      {label && (
        <div
          style={{
            fontSize: 11,
            textTransform: 'uppercase',
            letterSpacing: '0.06em',
            color: 'var(--ink-faint)',
            fontWeight: 600,
            marginBottom: 8,
          }}
        >
          {label}
        </div>
      )}
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        {options.map((o) => (
          <button
            type="button"
            key={o.value}
            className={'langcard' + (o.value === value ? ' on' : '') + (o.muted ? ' muted' : '')}
            onClick={() => onChange(o.value)}
          >
            <span className="lc-top">
              <span className="lc-main">{o.label}</span>
              {o.badge != null && <span className="lc-badge">{o.badge}</span>}
            </span>
            {o.sub && <span className="lc-sub">{o.sub}</span>}
          </button>
        ))}
      </div>
    </div>
  );
}
